// modifer: styles/jss/nextjs-material-kit-pro/pages/productStyle
import { cardTitle, grayColor } from 'styles/jss/original/base';

import tooltipsStyle from 'styles/jss/nextjs-material-kit-pro/tooltipsStyle.js';
import imagesStyles from 'styles/jss/nextjs-material-kit-pro/imagesStyles.js';

const styles = {
  ...imagesStyles,
  ...tooltipsStyle,
  flex: {
    display: 'flex'
  },
  cardCategory: {
    textAlign: 'center',
    marginTop: '10px',
    color: grayColor[0]
  },
  cardTitle: {
    ...cardTitle,
    textAlign: 'center'
  },
  cardBody: {
    padding: '0.9375rem 1.25rem 0',
    '@media (max-width: 640px)': {
      padding: '0.9375rem 0.625rem 0'
    }
  },
  cardFooter: {
    justifyContent: 'flex-end',
    padding: '0.9375rem 1.25rem 0.9375rem 1.875rem',
    '@media (max-width: 640px)': {
      padding: '0.9375rem 0.625rem'
    },

    '& svg': {
      width: '24px',
      height: '24px'
    }
  }
};

export default styles;
